module.exports = __webpack_public_path__ + "static/img/jingdongyun.03e6eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingdongyun.png
// module id = OdgH
// module chunks = 0